import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Banner_AdminBanner, Banner_DesktopImageUploaded_$reflection, Banner_AdminBanner_$reflection, Banner_AdminBannerListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { defaultOf, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { errorCmd, Loaded, request, postEmpty } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { bool_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { BannerModel, BannerListModel, BannerListModel_Init_Z524259A4, Msg, Model, BannerModel_Init } from "./Types.fs.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { dateUpdate, update } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { Markdown_ToHtml_1BFEAEDB } from "../../../fable_modules/Fable.Formatting.Markdown.1.0.1/Markdown.fs.js";
import { today } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { value as value_8 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";

export function Http_getBannerList(page, filter) {
    const response = fetch((filter.tag === 1) ? (`/api/admin/banner/pflege?page=${page}`) : ((filter.tag === 2) ? (`/api/admin/banner/therapie?page=${page}`) : ((filter.tag === 3) ? (`/api/admin/banner/bfsplus?page=${page}`) : ((filter.tag === 4) ? (`/api/admin/banner/jugendhilfe?page=${page}`) : (`/api/admin/banner?page=${page}`)))), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Paginated$1_$reflection(Banner_AdminBannerListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getBanner(id) {
    const response = fetch(`/api/admin/banner/${encodeURIComponent(id)}`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Banner_AdminBanner_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postBanner(id, banner) {
    return sendJson(`/api/admin/banner/${encodeURIComponent(id)}`, toString(0, Auto_generateBoxedEncoder_437914C6(Banner_AdminBanner_$reflection(), undefined, undefined, undefined)(banner)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_postActivate(id) {
    return postEmpty(`/api/admin/banner/${encodeURIComponent(id)}/active`);
}

export function Http_postDeactivate(id) {
    return postEmpty(`/api/admin/banner/${encodeURIComponent(id)}/inactive`);
}

export function Http_postImageDesktop(id, file) {
    const url = `/api/admin/banner/${encodeURIComponent(id)}/image/desktop`;
    const formData = new FormData();
    formData.append("file", file);
    const response = fetch(url, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [((Item) => (new Types_HttpRequestHeaders(11, [Item])))("multipart/form-data")]), new Types_RequestProperties(2, [formData])])), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Banner_DesktopImageUploaded_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postImageMobile(id, file) {
    const url = `/api/admin/banner/${encodeURIComponent(id)}/image/mobile`;
    const formData = new FormData();
    formData.append("file", file);
    const response = fetch(url, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [((Item) => (new Types_HttpRequestHeaders(11, [Item])))("multipart/form-data")]), new Types_RequestProperties(2, [formData])])), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(bool_type, new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(page, session, lastModel) {
    let m, m_1;
    switch (page.tag) {
        case 1: {
            const id = page.fields[0];
            return [new Model(1, [BannerModel_Init(id, (lastModel != null) ? ((lastModel.tag === 0) ? ((m = lastModel.fields[0], m.PageNumber)) : 1) : 1, session)]), singleton((dispatch_1) => {
                dispatch_1(new Msg(7, [id]));
            })];
        }
        case 2:
            return [new Model(1, [BannerModel_Init(undefined, (lastModel != null) ? ((lastModel.tag === 0) ? ((m_1 = lastModel.fields[0], m_1.PageNumber)) : 1) : 1, session)]), singleton((dispatch_2) => {
                dispatch_2(new Msg(6, []));
            })];
        default: {
            const pagenumber = page.fields[0] | 0;
            return [new Model(0, [BannerListModel_Init_Z524259A4(pagenumber)]), singleton((dispatch) => {
                dispatch(new Msg(0, [pagenumber]));
            })];
        }
    }
}

export function State_update(msg, model) {
    let Titel, Tag, Text$, TextAsHtml, matchValue_1;
    let matchResult, model_1, pagenumber, model_2, x, filter_1, model_3, id, id_2, model_4, id_4, jobmodel, banner, model_6, exn, model_7, model_8, value, model_9, value_1, model_10, value_2, date, model_11, state, date_1, model_12, state_1, model_13, value_3, model_14, value_4, model_15, value_5, model_16, value_6, model_17, file_1, model_18, model_19, result, exn_2, model_20, model_21, file_4, model_22, hasImage, model_23, exn_4, model_24, model_25, model_26, e, model_27, id_13, model_28, e_1, model_29, model_30;
    switch (msg.tag) {
        case 1: {
            if (model.tag === 0) {
                matchResult = 1;
                model_2 = model.fields[0];
                x = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 2: {
            if (model.tag === 0) {
                matchResult = 2;
                filter_1 = msg.fields[0];
                model_3 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 3: {
            matchResult = 3;
            id = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 4;
            id_2 = msg.fields[0];
            break;
        }
        case 5: {
            if (model.tag === 0) {
                matchResult = 5;
                model_4 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 7: {
            if (model.tag === 1) {
                matchResult = 6;
                id_4 = msg.fields[0];
                jobmodel = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 8: {
            if (msg.fields[0].tag === 1) {
                matchResult = 8;
                exn = msg.fields[0].fields[0];
            }
            else if (model.tag === 1) {
                matchResult = 7;
                banner = msg.fields[0].fields[0];
                model_6 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 6: {
            if (model.tag === 1) {
                matchResult = 9;
                model_7 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 10: {
            if (model.tag === 1) {
                matchResult = 10;
                model_8 = model.fields[0];
                value = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 9: {
            if (model.tag === 1) {
                matchResult = 11;
                model_9 = model.fields[0];
                value_1 = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 11: {
            if (model.tag === 1) {
                matchResult = 12;
                model_10 = model.fields[0];
                value_2 = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 12: {
            if (model.tag === 1) {
                matchResult = 13;
                date = msg.fields[1];
                model_11 = model.fields[0];
                state = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 13: {
            if (model.tag === 1) {
                matchResult = 14;
                date_1 = msg.fields[1];
                model_12 = model.fields[0];
                state_1 = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 14: {
            if (model.tag === 1) {
                matchResult = 15;
                model_13 = model.fields[0];
                value_3 = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 15: {
            if (model.tag === 1) {
                matchResult = 16;
                model_14 = model.fields[0];
                value_4 = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 16: {
            if (model.tag === 1) {
                matchResult = 17;
                model_15 = model.fields[0];
                value_5 = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 17: {
            if (model.tag === 1) {
                matchResult = 18;
                model_16 = model.fields[0];
                value_6 = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 18: {
            if (model.tag === 1) {
                matchResult = 19;
                model_17 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 19: {
            if (model.tag === 1) {
                matchResult = 20;
                file_1 = msg.fields[0];
                model_18 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 20: {
            if (msg.fields[0].tag === 1) {
                matchResult = 22;
                exn_2 = msg.fields[0].fields[0];
                model_20 = model;
            }
            else if (model.tag === 1) {
                matchResult = 21;
                model_19 = model.fields[0];
                result = msg.fields[0].fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 21: {
            if (model.tag === 1) {
                matchResult = 23;
                model_21 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 22: {
            if (model.tag === 1) {
                matchResult = 24;
                file_4 = msg.fields[0];
                model_22 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 23: {
            if (msg.fields[0].tag === 1) {
                matchResult = 26;
                exn_4 = msg.fields[0].fields[0];
                model_24 = model;
            }
            else if (model.tag === 1) {
                matchResult = 25;
                hasImage = msg.fields[0].fields[0];
                model_23 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 24: {
            if (model.tag === 1) {
                matchResult = 27;
                model_25 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 25: {
            if (msg.fields[0].tag === 1) {
                if (model.tag === 1) {
                    matchResult = 29;
                    e = msg.fields[0].fields[0];
                    model_27 = model.fields[0];
                }
                else {
                    matchResult = 34;
                }
            }
            else if (model.tag === 1) {
                matchResult = 28;
                model_26 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 26: {
            if (msg.fields[0].tag === 1) {
                if (model.tag === 1) {
                    matchResult = 31;
                    e_1 = msg.fields[0].fields[0];
                    model_29 = model.fields[0];
                }
                else {
                    matchResult = 34;
                }
            }
            else if (model.tag === 1) {
                matchResult = 30;
                id_13 = msg.fields[0].fields[0];
                model_28 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 27: {
            if (model.tag === 1) {
                matchResult = 32;
                model_30 = model.fields[0];
            }
            else {
                matchResult = 34;
            }
            break;
        }
        case 28: {
            matchResult = 33;
            break;
        }
        default:
            if (model.tag === 0) {
                matchResult = 0;
                model_1 = model.fields[0];
                pagenumber = msg.fields[0];
            }
            else {
                matchResult = 34;
            }
    }
    switch (matchResult) {
        case 0:
            return [new Model(0, [new BannerListModel(model_1.PageNumber, model_1.Filter, new Remote$1(1, []))]), request((tupledArg) => Http_getBannerList(tupledArg[0], tupledArg[1]), [pagenumber, model_1.Filter], (Item) => (new Msg(1, [Item])))];
        case 1:
            return [new Model(0, [new BannerListModel(model_2.PageNumber, model_2.Filter, Loaded(x))]), Cmd_none()];
        case 2:
            return [new Model(0, [new BannerListModel(model_3.PageNumber, filter_1, model_3.Banner)]), singleton((dispatch) => {
                dispatch(new Msg(0, [1]));
            })];
        case 3:
            return [model, request(Http_postActivate, id, (Item_4) => (new Msg(5, [Item_4])))];
        case 4:
            return [model, request(Http_postDeactivate, id_2, (Item_5) => (new Msg(5, [Item_5])))];
        case 5:
            return [new Model(0, [model_4]), singleton((dispatch_1) => {
                dispatch_1(new Msg(0, [model_4.PageNumber]));
            })];
        case 6:
            return [new Model(1, [new BannerModel(id_4, jobmodel.BackToPage, jobmodel.Tag, jobmodel.HintergrundFarbe, jobmodel.TextFarbe, jobmodel.Titel, jobmodel.Text, jobmodel.GueltigAb, jobmodel.GueltigBis, jobmodel.Aktiv, jobmodel.KundenTyp, jobmodel.HasImageDesktop, jobmodel.HasImageMobile, jobmodel.ImageOnly, jobmodel.ImageOnlyEnabled, jobmodel.IsDirty, jobmodel.Sending, jobmodel.TextAsHtml, jobmodel.UserSession, jobmodel.UploadTrigger)]), request(Http_getBanner, id_4, (Item_7) => (new Msg(8, [Item_7])))];
        case 7:
            return [new Model(1, [(Titel = update(model_6.Titel, banner.Titel), (Tag = update(model_6.Tag, banner.Tag), (Text$ = update(model_6.Text, banner.Text), (TextAsHtml = Markdown_ToHtml_1BFEAEDB(banner.Text), new BannerModel(model_6.Id, model_6.BackToPage, Tag, banner.HintergrundFarbe, banner.TextFarbe, Titel, Text$, dateUpdate(model_6.GueltigAb, model_6.GueltigAb.DatePickerState, banner.GueltigAb, banner.GueltigAb), dateUpdate(model_6.GueltigBis, model_6.GueltigBis.DatePickerState, banner.GueltigBis, banner.GueltigBis), banner.Aktiv, banner.KundenTyp, banner.HasImageDesktop, banner.HasImageMobile, banner.ImageOnly, model_6.ImageOnlyEnabled, false, model_6.Sending, TextAsHtml, model_6.UserSession, model_6.UploadTrigger)))))]), singleton((dispatch_2) => {
                dispatch_2(new Msg(27, []));
            })];
        case 8:
            return [model, errorCmd((Item_9) => (new Msg(28, [Item_9])), "Laden", exn)];
        case 9:
            return [new Model(1, [new BannerModel(model_7.Id, model_7.BackToPage, model_7.Tag, model_7.HintergrundFarbe, "#4A4A4A", update(model_7.Titel, "Neuer Banner"), model_7.Text, dateUpdate(model_7.GueltigAb, model_7.GueltigAb.DatePickerState, today(), today()), dateUpdate(model_7.GueltigBis, model_7.GueltigBis.DatePickerState, today(), today()), true, model_7.KundenTyp, model_7.HasImageDesktop, model_7.HasImageMobile, model_7.ImageOnly, model_7.ImageOnlyEnabled, true, model_7.Sending, model_7.TextAsHtml, model_7.UserSession, model_7.UploadTrigger)]), Cmd_none()];
        case 10:
            return [new Model(1, [new BannerModel(model_8.Id, model_8.BackToPage, model_8.Tag, model_8.HintergrundFarbe, model_8.TextFarbe, update(model_8.Titel, value), model_8.Text, model_8.GueltigAb, model_8.GueltigBis, model_8.Aktiv, model_8.KundenTyp, model_8.HasImageDesktop, model_8.HasImageMobile, model_8.ImageOnly, model_8.ImageOnlyEnabled, true, model_8.Sending, model_8.TextAsHtml, model_8.UserSession, model_8.UploadTrigger)]), Cmd_none()];
        case 11:
            return [new Model(1, [new BannerModel(model_9.Id, model_9.BackToPage, update(model_9.Tag, value_1), model_9.HintergrundFarbe, model_9.TextFarbe, model_9.Titel, model_9.Text, model_9.GueltigAb, model_9.GueltigBis, model_9.Aktiv, model_9.KundenTyp, model_9.HasImageDesktop, model_9.HasImageMobile, model_9.ImageOnly, model_9.ImageOnlyEnabled, true, model_9.Sending, model_9.TextAsHtml, model_9.UserSession, model_9.UploadTrigger)]), Cmd_none()];
        case 12:
            return [new Model(1, [new BannerModel(model_10.Id, model_10.BackToPage, model_10.Tag, model_10.HintergrundFarbe, model_10.TextFarbe, model_10.Titel, update(model_10.Text, value_2), model_10.GueltigAb, model_10.GueltigBis, model_10.Aktiv, model_10.KundenTyp, model_10.HasImageDesktop, model_10.HasImageMobile, model_10.ImageOnly, model_10.ImageOnlyEnabled, true, model_10.Sending, Markdown_ToHtml_1BFEAEDB(value_2), model_10.UserSession, model_10.UploadTrigger)]), Cmd_none()];
        case 13:
            return [new Model(1, [new BannerModel(model_11.Id, model_11.BackToPage, model_11.Tag, model_11.HintergrundFarbe, model_11.TextFarbe, model_11.Titel, model_11.Text, dateUpdate(model_11.GueltigAb, state, date, undefined), model_11.GueltigBis, model_11.Aktiv, model_11.KundenTyp, model_11.HasImageDesktop, model_11.HasImageMobile, model_11.ImageOnly, model_11.ImageOnlyEnabled, true, model_11.Sending, model_11.TextAsHtml, model_11.UserSession, model_11.UploadTrigger)]), Cmd_none()];
        case 14:
            return [new Model(1, [new BannerModel(model_12.Id, model_12.BackToPage, model_12.Tag, model_12.HintergrundFarbe, model_12.TextFarbe, model_12.Titel, model_12.Text, model_12.GueltigAb, dateUpdate(model_12.GueltigBis, state_1, date_1, undefined), model_12.Aktiv, model_12.KundenTyp, model_12.HasImageDesktop, model_12.HasImageMobile, model_12.ImageOnly, model_12.ImageOnlyEnabled, true, model_12.Sending, model_12.TextAsHtml, model_12.UserSession, model_12.UploadTrigger)]), Cmd_none()];
        case 15:
            return [new Model(1, [new BannerModel(model_13.Id, model_13.BackToPage, model_13.Tag, model_13.HintergrundFarbe, model_13.TextFarbe, model_13.Titel, model_13.Text, model_13.GueltigAb, model_13.GueltigBis, value_3, model_13.KundenTyp, model_13.HasImageDesktop, model_13.HasImageMobile, model_13.ImageOnly, model_13.ImageOnlyEnabled, true, model_13.Sending, model_13.TextAsHtml, model_13.UserSession, model_13.UploadTrigger)]), Cmd_none()];
        case 16:
            return [new Model(1, [new BannerModel(model_14.Id, model_14.BackToPage, model_14.Tag, model_14.HintergrundFarbe, model_14.TextFarbe, model_14.Titel, model_14.Text, model_14.GueltigAb, model_14.GueltigBis, model_14.Aktiv, model_14.KundenTyp, model_14.HasImageDesktop, model_14.HasImageMobile, value_4, model_14.ImageOnlyEnabled, true, model_14.Sending, model_14.TextAsHtml, model_14.UserSession, model_14.UploadTrigger)]), Cmd_none()];
        case 17:
            return [new Model(1, [new BannerModel(model_15.Id, model_15.BackToPage, model_15.Tag, model_15.HintergrundFarbe, model_15.TextFarbe, model_15.Titel, model_15.Text, model_15.GueltigAb, model_15.GueltigBis, model_15.Aktiv, value_5, model_15.HasImageDesktop, model_15.HasImageMobile, model_15.ImageOnly, model_15.ImageOnlyEnabled, true, model_15.Sending, model_15.TextAsHtml, model_15.UserSession, model_15.UploadTrigger)]), Cmd_none()];
        case 18:
            return [new Model(1, [new BannerModel(model_16.Id, model_16.BackToPage, model_16.Tag, model_16.HintergrundFarbe, value_6, model_16.Titel, model_16.Text, model_16.GueltigAb, model_16.GueltigBis, model_16.Aktiv, model_16.KundenTyp, model_16.HasImageDesktop, model_16.HasImageMobile, model_16.ImageOnly, model_16.ImageOnlyEnabled, true, model_16.Sending, model_16.TextAsHtml, model_16.UserSession, model_16.UploadTrigger)]), Cmd_none()];
        case 19:
            return [new Model(1, [model_17]), request((tupledArg_1) => Http_postImageDesktop(tupledArg_1[0], tupledArg_1[1]), [value_8(model_17.Id), defaultOf()], (Item_21) => (new Msg(20, [Item_21])))];
        case 20:
            return [new Model(1, [model_18]), request((tupledArg_2) => Http_postImageDesktop(tupledArg_2[0], tupledArg_2[1]), [value_8(model_18.Id), file_1], (Item_23) => (new Msg(20, [Item_23])))];
        case 21:
            return [new Model(1, [new BannerModel(model_19.Id, model_19.BackToPage, model_19.Tag, result.HintergrundFarbe, model_19.TextFarbe, model_19.Titel, model_19.Text, model_19.GueltigAb, model_19.GueltigBis, model_19.Aktiv, model_19.KundenTyp, result.HasImage, model_19.HasImageMobile, model_19.ImageOnly, model_19.ImageOnlyEnabled, model_19.IsDirty, model_19.Sending, model_19.TextAsHtml, model_19.UserSession, model_19.UploadTrigger + 1)]), singleton((dispatch_3) => {
                dispatch_3(new Msg(27, []));
            })];
        case 22:
            return [model_20, errorCmd((Item_25) => (new Msg(28, [Item_25])), "Speichern des Bilds", exn_2)];
        case 23:
            return [new Model(1, [model_21]), request((tupledArg_3) => Http_postImageMobile(tupledArg_3[0], tupledArg_3[1]), [value_8(model_21.Id), defaultOf()], (Item_27) => (new Msg(23, [Item_27])))];
        case 24:
            return [new Model(1, [model_22]), request((tupledArg_4) => Http_postImageMobile(tupledArg_4[0], tupledArg_4[1]), [value_8(model_22.Id), file_4], (Item_29) => (new Msg(23, [Item_29])))];
        case 25:
            return [new Model(1, [new BannerModel(model_23.Id, model_23.BackToPage, model_23.Tag, model_23.HintergrundFarbe, model_23.TextFarbe, model_23.Titel, model_23.Text, model_23.GueltigAb, model_23.GueltigBis, model_23.Aktiv, model_23.KundenTyp, model_23.HasImageDesktop, hasImage, model_23.ImageOnly, model_23.ImageOnlyEnabled, model_23.IsDirty, model_23.Sending, model_23.TextAsHtml, model_23.UserSession, model_23.UploadTrigger + 1)]), singleton((dispatch_4) => {
                dispatch_4(new Msg(27, []));
            })];
        case 26:
            return [model_24, errorCmd((Item_31) => (new Msg(28, [Item_31])), "Speichern des Bilds", exn_4)];
        case 27: {
            const banner_1 = new Banner_AdminBanner(model_25.Titel.Value, model_25.Tag.Value, model_25.Text.Value, model_25.HasImageDesktop, model_25.HasImageMobile, model_25.HintergrundFarbe, model_25.TextFarbe, model_25.KundenTyp, value_8(model_25.GueltigAb.Value), value_8(model_25.GueltigBis.Value), model_25.Aktiv, model_25.ImageOnly);
            return [new Model(1, [new BannerModel(model_25.Id, model_25.BackToPage, model_25.Tag, model_25.HintergrundFarbe, model_25.TextFarbe, model_25.Titel, model_25.Text, model_25.GueltigAb, model_25.GueltigBis, model_25.Aktiv, model_25.KundenTyp, model_25.HasImageDesktop, model_25.HasImageMobile, model_25.ImageOnly, model_25.ImageOnlyEnabled, model_25.IsDirty, true, model_25.TextAsHtml, model_25.UserSession, model_25.UploadTrigger)]), (matchValue_1 = model_25.Id, (matchValue_1 == null) ? request((banner_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (sendJson("/api/admin/banner", toString(0, Auto_generateBoxedEncoder_437914C6(Banner_AdminBanner_$reflection(), undefined, undefined, undefined)(banner_3)), singleton(new Types_RequestProperties(4, ["include"])), "PUT").then((_arg) => (_arg.json().then((_arg_1) => (Promise.resolve(_arg_1)))))))), banner_1, (Item_33) => (new Msg(26, [Item_33]))) : request((tupledArg_5) => Http_postBanner(tupledArg_5[0], tupledArg_5[1]), [matchValue_1, banner_1], (Item_32) => (new Msg(25, [Item_32]))))];
        }
        case 28:
            return [new Model(1, [new BannerModel(model_26.Id, model_26.BackToPage, model_26.Tag, model_26.HintergrundFarbe, model_26.TextFarbe, model_26.Titel, model_26.Text, model_26.GueltigAb, model_26.GueltigBis, model_26.Aktiv, model_26.KundenTyp, model_26.HasImageDesktop, model_26.HasImageMobile, model_26.ImageOnly, model_26.ImageOnlyEnabled, false, false, model_26.TextAsHtml, model_26.UserSession, model_26.UploadTrigger)]), Cmd_none()];
        case 29:
            return [new Model(1, [new BannerModel(model_27.Id, model_27.BackToPage, model_27.Tag, model_27.HintergrundFarbe, model_27.TextFarbe, model_27.Titel, model_27.Text, model_27.GueltigAb, model_27.GueltigBis, model_27.Aktiv, model_27.KundenTyp, model_27.HasImageDesktop, model_27.HasImageMobile, model_27.ImageOnly, model_27.ImageOnlyEnabled, model_27.IsDirty, false, model_27.TextAsHtml, model_27.UserSession, model_27.UploadTrigger)]), errorCmd((Item_37) => (new Msg(28, [Item_37])), "Speichern", e)];
        case 30:
            return [new Model(1, [new BannerModel(id_13, model_28.BackToPage, model_28.Tag, model_28.HintergrundFarbe, model_28.TextFarbe, model_28.Titel, model_28.Text, model_28.GueltigAb, model_28.GueltigBis, model_28.Aktiv, model_28.KundenTyp, model_28.HasImageDesktop, model_28.HasImageMobile, model_28.ImageOnly, model_28.ImageOnlyEnabled, false, false, model_28.TextAsHtml, model_28.UserSession, model_28.UploadTrigger)]), Cmd_none()];
        case 31:
            return [new Model(1, [new BannerModel(model_29.Id, model_29.BackToPage, model_29.Tag, model_29.HintergrundFarbe, model_29.TextFarbe, model_29.Titel, model_29.Text, model_29.GueltigAb, model_29.GueltigBis, model_29.Aktiv, model_29.KundenTyp, model_29.HasImageDesktop, model_29.HasImageMobile, model_29.ImageOnly, model_29.ImageOnlyEnabled, model_29.IsDirty, false, model_29.TextAsHtml, model_29.UserSession, model_29.UploadTrigger)]), errorCmd((Item_40) => (new Msg(28, [Item_40])), "Speichern", e_1)];
        case 32:
            return [new Model(1, [(model_30.HasImageDesktop && model_30.HasImageMobile) ? (new BannerModel(model_30.Id, model_30.BackToPage, model_30.Tag, model_30.HintergrundFarbe, model_30.TextFarbe, model_30.Titel, model_30.Text, model_30.GueltigAb, model_30.GueltigBis, model_30.Aktiv, model_30.KundenTyp, model_30.HasImageDesktop, model_30.HasImageMobile, model_30.ImageOnly, true, model_30.IsDirty, model_30.Sending, model_30.TextAsHtml, model_30.UserSession, model_30.UploadTrigger)) : (new BannerModel(model_30.Id, model_30.BackToPage, model_30.Tag, model_30.HintergrundFarbe, model_30.TextFarbe, model_30.Titel, model_30.Text, model_30.GueltigAb, model_30.GueltigBis, model_30.Aktiv, model_30.KundenTyp, model_30.HasImageDesktop, model_30.HasImageMobile, false, false, model_30.IsDirty, model_30.Sending, model_30.TextAsHtml, model_30.UserSession, model_30.UploadTrigger))]), Cmd_none()];
        case 33:
            return [model, Cmd_none()];
        default: {
            return [model, Cmd_none()];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
